import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/datenschutz")({
  head: () => ({
    meta: [
      { title: "Datenschutzerklärung — PIXIWEB" },
      { name: "description", content: "Informationen zur Verarbeitung personenbezogener Daten gemäß DSGVO bei PIXIWEB." },
      { name: "robots", content: "noindex,follow" },
      { property: "og:title", content: "Datenschutzerklärung — PIXIWEB" },
      { property: "og:description", content: "Informationen zur Verarbeitung personenbezogener Daten gemäß DSGVO bei PIXIWEB — transparent und rechtssicher." },
      { property: "og:url", content: "https://pixiweb.de/datenschutz" },
    ],
    links: [{ rel: "canonical", href: "https://pixiweb.de/datenschutz" }],
  }),
  component: DatenschutzPage,
});

function DatenschutzPage() {
  return (
    <div>
      <section className="border-b border-mist bg-ice">
        <div className="container-pixi py-16">
          <p className="eyebrow">Rechtliches</p>
          <h1 className="mt-3 font-display text-5xl font-bold">Datenschutz­erklärung</h1>
          <p className="mt-3 max-w-2xl text-slate">
            Stand: {new Date().toLocaleDateString("de-DE", { month: "long", year: "numeric" })}
          </p>
        </div>
      </section>

      <article className="container-pixi max-w-3xl space-y-12 py-16 text-base leading-relaxed text-navy">
        {/* 1. Datenschutz auf einen Blick */}
        <section className="space-y-6">
          <h2 className="font-display text-3xl font-bold">1. Datenschutz auf einen Blick</h2>

          <div>
            <h3 className="font-display text-xl font-semibold">Allgemeine Hinweise</h3>
            <p className="mt-3">
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten
              passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
              persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie
              unserer unter diesem Text aufgeführten Datenschutzerklärung.
            </p>
          </div>

          <div>
            <h3 className="font-display text-xl font-semibold">Datenerfassung auf dieser Website</h3>
            <p className="mt-3 font-semibold">Wer ist verantwortlich für die Datenerfassung auf dieser Website?</p>
            <p className="mt-2">
              Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können
              Sie dem Abschnitt „Hinweis zur verantwortlichen Stelle" in dieser Datenschutzerklärung entnehmen.
            </p>

            <p className="mt-4 font-semibold">Wie erfassen wir Ihre Daten?</p>
            <p className="mt-2">
              Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um
              Daten handeln, die Sie in ein Kontaktformular eingeben.
            </p>
            <p className="mt-2">
              Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere
              IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder
              Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website
              betreten.
            </p>

            <p className="mt-4 font-semibold">Wofür nutzen wir Ihre Daten?</p>
            <p className="mt-2">
              Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere
              Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden. Sofern über die Website Verträge
              geschlossen oder angebahnt werden können, werden die übermittelten Daten auch für Vertragsangebote,
              Bestellungen oder sonstige Auftragsanfragen verarbeitet.
            </p>

            <p className="mt-4 font-semibold">Welche Rechte haben Sie bezüglich Ihrer Daten?</p>
            <p className="mt-2">
              Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer
              gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder
              Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben,
              können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter
              bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des
              Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
            </p>
            <p className="mt-2">
              Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden.
            </p>
          </div>

          <div>
            <h3 className="font-display text-xl font-semibold">Analyse-Tools und Tools von Drittanbietern</h3>
            <p className="mt-3">
              Beim Besuch dieser Website kann Ihr Surf-Verhalten statistisch ausgewertet werden. Das geschieht vor
              allem mit sogenannten Analyseprogrammen.
            </p>
            <p className="mt-2">
              Detaillierte Informationen zu diesen Analyseprogrammen finden Sie in der folgenden
              Datenschutzerklärung.
            </p>
          </div>
        </section>

        {/* 2. Hosting */}
        <section className="space-y-6">
          <h2 className="font-display text-3xl font-bold">2. Hosting und Content Delivery Networks (CDN)</h2>
          <p>Wir hosten die Inhalte unserer Website bei folgendem Anbieter:</p>

          <div>
            <h3 className="font-display text-xl font-semibold">Externes Hosting</h3>
            <p className="mt-3">
              Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website erfasst werden,
              werden auf den Servern des Hosters / der Hoster gespeichert. Hierbei kann es sich v. a. um IP-Adressen,
              Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe und
              sonstige Daten, die über eine Website generiert werden, handeln.
            </p>
            <p className="mt-3">
              Das externe Hosting erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen und
              bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und
              effizienten Bereitstellung unseres Online-Angebots durch einen professionellen Anbieter (Art. 6 Abs. 1
              lit. f DSGVO). Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung
              ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG, soweit die
              Einwilligung die Speicherung von Cookies oder den Zugriff auf Informationen im Endgerät des Nutzers
              (z. B. Device-Fingerprinting) im Sinne des TDDDG umfasst. Die Einwilligung ist jederzeit widerrufbar.
            </p>
            <p className="mt-3">
              Unser(e) Hoster wird bzw. werden Ihre Daten nur insoweit verarbeiten, wie dies zur Erfüllung seiner
              Leistungspflichten erforderlich ist und unsere Weisungen in Bezug auf diese Daten befolgen.
            </p>
            <p className="mt-3">Wir setzen folgende(n) Hoster ein:</p>
            <p className="mt-2">
              Lovable Labs AB<br />
              Regeringsgatan 29<br />
              111 53 Stockholm<br />
              Schweden
            </p>
          </div>

          <div>
            <h3 className="font-display text-lg font-semibold">Auftragsverarbeitung</h3>
            <p className="mt-3">
              Wir haben einen Vertrag über Auftragsverarbeitung (AVV) zur Nutzung des oben genannten Dienstes
              geschlossen. Hierbei handelt es sich um einen datenschutzrechtlich vorgeschriebenen Vertrag, der
              gewährleistet, dass dieser die personenbezogenen Daten unserer Websitebesucher nur nach unseren
              Weisungen und unter Einhaltung der DSGVO verarbeitet.
            </p>
          </div>

          <div>
            <h3 className="font-display text-xl font-semibold">Cloudflare</h3>
            <p className="mt-3">
              Wir nutzen den Service „Cloudflare". Anbieter ist die Cloudflare Inc., 101 Townsend St., San Francisco,
              CA 94107, USA (im Folgenden „Cloudflare").
            </p>
            <p className="mt-3">
              Cloudflare bietet ein weltweit verteiltes Content Delivery Network mit DNS an. Dabei wird technisch der
              Informationstransfer zwischen Ihrem Browser und unserer Website über das Netzwerk von Cloudflare
              geleitet. Das versetzt Cloudflare in die Lage, den Datenverkehr zwischen Ihrem Browser und unserer
              Website zu analysieren und als Filter zwischen unseren Servern und potenziell bösartigem Datenverkehr
              aus dem Internet zu dienen. Hierbei kann Cloudflare auch Cookies oder sonstige Technologien zur
              Wiedererkennung von Internetnutzern einsetzen, die jedoch allein zum hier beschriebenen Zweck verwendet
              werden.
            </p>
            <p className="mt-3">
              Der Einsatz von Cloudflare beruht auf unserem berechtigten Interesse an einer möglichst fehlerfreien und
              sicheren Bereitstellung unseres Webangebotes (Art. 6 Abs. 1 lit. f DSGVO).
            </p>
            <p className="mt-3">
              Die Datenübertragung in die USA wird auf die Standardvertragsklauseln der EU-Kommission gestützt.
              Details und weitere Informationen zum Thema Sicherheit und Datenschutz bei Cloudflare finden Sie hier:{" "}
              <a className="text-electric hover:underline" href="https://www.cloudflare.com/privacypolicy/" target="_blank" rel="noreferrer">
                https://www.cloudflare.com/privacypolicy/
              </a>
              .
            </p>
            <p className="mt-3">
              Das Unternehmen verfügt über eine Zertifizierung nach dem „EU-US Data Privacy Framework" (DPF). Der DPF
              ist ein Übereinkommen zwischen der Europäischen Union und den USA, der die Einhaltung europäischer
              Datenschutzstandards bei Datenverarbeitungen in den USA gewährleisten soll. Jedes nach dem DPF
              zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere
              Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link:{" "}
              <a className="text-electric hover:underline" href="https://www.dataprivacyframework.gov/participant/5666" target="_blank" rel="noreferrer">
                https://www.dataprivacyframework.gov/participant/5666
              </a>
              .
            </p>
          </div>

          <div>
            <h3 className="font-display text-lg font-semibold">Auftragsverarbeitung</h3>
            <p className="mt-3">
              Wir haben einen Vertrag über Auftragsverarbeitung (AVV) zur Nutzung des oben genannten Dienstes
              geschlossen. Hierbei handelt es sich um einen datenschutzrechtlich vorgeschriebenen Vertrag, der
              gewährleistet, dass dieser die personenbezogenen Daten unserer Websitebesucher nur nach unseren
              Weisungen und unter Einhaltung der DSGVO verarbeitet.
            </p>
          </div>
        </section>

        {/* 3. Allgemeine Hinweise und Pflichtinformationen */}
        <section className="space-y-6">
          <h2 className="font-display text-3xl font-bold">3. Allgemeine Hinweise und Pflichtinformationen</h2>

          <div>
            <h3 className="font-display text-xl font-semibold">Datenschutz</h3>
            <p className="mt-3">
              Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre
              personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie
              dieser Datenschutzerklärung.
            </p>
            <p className="mt-3">
              Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene
              Daten sind Daten, mit denen Sie persönlich identifiziert werden können. Die vorliegende
              Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie erläutert auch,
              wie und zu welchem Zweck das geschieht.
            </p>
            <p className="mt-3">
              Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B. bei der Kommunikation per E-Mail)
              Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist
              nicht möglich.
            </p>
          </div>

          <div>
            <h3 className="font-display text-xl font-semibold">Hinweis zur verantwortlichen Stelle</h3>
            <p className="mt-3">Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
            <p className="mt-3">
              Daniel Peters<br />
              Vor dem Esch 7<br />
              32609 Hüllhorst
            </p>
            <p className="mt-3">
              Telefon:{" "}
              <a className="text-electric hover:underline" href="tel:+4917640417218">
                +49 176 40417218
              </a>
              <br />
              E-Mail:{" "}
              <a className="text-electric hover:underline" href="mailto:kontakt@pixiweb.de">
                kontakt@pixiweb.de
              </a>
            </p>
            <p className="mt-3">
              Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen
              über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z. B. Namen, E-Mail-Adressen
              o. Ä.) entscheidet.
            </p>
          </div>

          <div>
            <h3 className="font-display text-xl font-semibold">Speicherdauer</h3>
            <p className="mt-3">
              Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben
              Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein
              berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen,
              werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung
              Ihrer personenbezogenen Daten haben (z. B. steuer- oder handelsrechtliche Aufbewahrungsfristen); im
              letztgenannten Fall erfolgt die Löschung nach Fortfall dieser Gründe.
            </p>
          </div>

          <div>
            <h3 className="font-display text-xl font-semibold">
              Allgemeine Hinweise zu den Rechtsgrundlagen der Datenverarbeitung auf dieser Website
            </h3>
            <p className="mt-3">
              Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten wir Ihre personenbezogenen Daten auf
              Grundlage von Art. 6 Abs. 1 lit. a DSGVO bzw. Art. 9 Abs. 2 lit. a DSGVO, sofern besondere
              Datenkategorien nach Art. 9 Abs. 1 DSGVO verarbeitet werden. Im Falle einer ausdrücklichen Einwilligung
              in die Übertragung personenbezogener Daten in Drittstaaten erfolgt die Datenverarbeitung außerdem auf
              Grundlage von Art. 49 Abs. 1 lit. a DSGVO. Sofern Sie in die Speicherung von Cookies oder in den Zugriff
              auf Informationen in Ihr Endgerät (z. B. via Device-Fingerprinting) eingewilligt haben, erfolgt die
              Datenverarbeitung zusätzlich auf Grundlage von § 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit
              widerrufbar. Sind Ihre Daten zur Vertragserfüllung oder zur Durchführung vorvertraglicher Maßnahmen
              erforderlich, verarbeiten wir Ihre Daten auf Grundlage des Art. 6 Abs. 1 lit. b DSGVO. Des Weiteren
              verarbeiten wir Ihre Daten, sofern diese zur Erfüllung einer rechtlichen Verpflichtung erforderlich
              sind, auf Grundlage von Art. 6 Abs. 1 lit. c DSGVO. Die Datenverarbeitung kann ferner auf Grundlage
              unseres berechtigten Interesses nach Art. 6 Abs. 1 lit. f DSGVO erfolgen. Über die jeweils im Einzelfall
              einschlägigen Rechtsgrundlagen wird in den folgenden Absätzen dieser Datenschutzerklärung informiert.
            </p>
          </div>

          <div>
            <h3 className="font-display text-xl font-semibold">Empfänger von personenbezogenen Daten</h3>
            <p className="mt-3">
              Im Rahmen unserer Geschäftstätigkeit arbeiten wir mit verschiedenen externen Stellen zusammen. Dabei ist
              teilweise auch eine Übermittlung von personenbezogenen Daten an diese externen Stellen erforderlich. Wir
              geben personenbezogene Daten nur dann an externe Stellen weiter, wenn dies im Rahmen einer
              Vertragserfüllung erforderlich ist, wenn wir gesetzlich hierzu verpflichtet sind (z. B. Weitergabe von
              Daten an Steuerbehörden), wenn wir ein berechtigtes Interesse nach Art. 6 Abs. 1 lit. f DSGVO an der
              Weitergabe haben oder wenn eine sonstige Rechtsgrundlage die Datenweitergabe erlaubt. Beim Einsatz von
              Auftragsverarbeitern geben wir personenbezogene Daten unserer Kunden nur auf Grundlage eines gültigen
              Vertrags über Auftragsverarbeitung weiter. Im Falle einer gemeinsamen Verarbeitung wird ein Vertrag über
              gemeinsame Verarbeitung geschlossen.
            </p>
          </div>

          <div>
            <h3 className="font-display text-xl font-semibold">Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
            <p className="mt-3">
              Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine
              bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten
              Datenverarbeitung bleibt vom Widerruf unberührt.
            </p>
          </div>

          <div>
            <h3 className="font-display text-xl font-semibold">
              Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie gegen Direktwerbung (Art. 21 DSGVO)
            </h3>
            <p className="mt-3">
              WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER F DSGVO ERFOLGT, HABEN SIE
              JEDERZEIT DAS RECHT, AUS GRÜNDEN, DIE SICH AUS IHRER BESONDEREN SITUATION ERGEBEN, GEGEN DIE
              VERARBEITUNG IHRER PERSONENBEZOGENEN DATEN WIDERSPRUCH EINZULEGEN; DIES GILT AUCH FÜR EIN AUF DIESE
              BESTIMMUNGEN GESTÜTZTES PROFILING. DIE JEWEILIGE RECHTSGRUNDLAGE, AUF DENEN EINE VERARBEITUNG BERUHT,
              ENTNEHMEN SIE DIESER DATENSCHUTZERKLÄRUNG. WENN SIE WIDERSPRUCH EINLEGEN, WERDEN WIR IHRE BETROFFENEN
              PERSONENBEZOGENEN DATEN NICHT MEHR VERARBEITEN, ES SEI DENN, WIR KÖNNEN ZWINGENDE SCHUTZWÜRDIGE GRÜNDE
              FÜR DIE VERARBEITUNG NACHWEISEN, DIE IHRE INTERESSEN, RECHTE UND FREIHEITEN ÜBERWIEGEN ODER DIE
              VERARBEITUNG DIENT DER GELTENDMACHUNG, AUSÜBUNG ODER VERTEIDIGUNG VON RECHTSANSPRÜCHEN (WIDERSPRUCH
              NACH ART. 21 ABS. 1 DSGVO).
            </p>
            <p className="mt-3">
              WERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET, UM DIREKTWERBUNG ZU BETREIBEN, SO HABEN SIE DAS RECHT,
              JEDERZEIT WIDERSPRUCH GEGEN DIE VERARBEITUNG SIE BETREFFENDER PERSONENBEZOGENER DATEN ZUM ZWECKE
              DERARTIGER WERBUNG EINZULEGEN; DIES GILT AUCH FÜR DAS PROFILING, SOWEIT ES MIT SOLCHER DIREKTWERBUNG IN
              VERBINDUNG STEHT. WENN SIE WIDERSPRECHEN, WERDEN IHRE PERSONENBEZOGENEN DATEN ANSCHLIESSEND NICHT MEHR
              ZUM ZWECKE DER DIREKTWERBUNG VERWENDET (WIDERSPRUCH NACH ART. 21 ABS. 2 DSGVO).
            </p>
          </div>

          <div>
            <h3 className="font-display text-xl font-semibold">
              Beschwerderecht bei der zuständigen Aufsichtsbehörde
            </h3>
            <p className="mt-3">
              Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer
              Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes
              oder des Orts des mutmaßlichen Verstoßes zu. Das Beschwerderecht besteht unbeschadet anderweitiger
              verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.
            </p>
          </div>

          <div>
            <h3 className="font-display text-xl font-semibold">Recht auf Datenübertragbarkeit</h3>
            <p className="mt-3">
              Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags
              automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format
              aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen
              verlangen, erfolgt dies nur, soweit es technisch machbar ist.
            </p>
          </div>

          <div>
            <h3 className="font-display text-xl font-semibold">Auskunft, Berichtigung und Löschung</h3>
            <p className="mt-3">
              Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche
              Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der
              Datenverarbeitung und ggf. ein Recht auf Berichtigung oder Löschung dieser Daten. Hierzu sowie zu
              weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit an uns wenden.
            </p>
          </div>

          <div>
            <h3 className="font-display text-xl font-semibold">Recht auf Einschränkung der Verarbeitung</h3>
            <p className="mt-3">
              Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
              Hierzu können Sie sich jederzeit an uns wenden. Das Recht auf Einschränkung der Verarbeitung besteht in
              folgenden Fällen:
            </p>
            <ul className="mt-3 list-disc space-y-2 pl-6">
              <li>
                Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen Daten bestreiten, benötigen wir
                in der Regel Zeit, um dies zu überprüfen. Für die Dauer der Prüfung haben Sie das Recht, die
                Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
              </li>
              <li>
                Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtmäßig geschah/geschieht, können Sie statt
                der Löschung die Einschränkung der Datenverarbeitung verlangen.
              </li>
              <li>
                Wenn wir Ihre personenbezogenen Daten nicht mehr benötigen, Sie sie jedoch zur Ausübung, Verteidigung
                oder Geltendmachung von Rechtsansprüchen benötigen, haben Sie das Recht, statt der Löschung die
                Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
              </li>
              <li>
                Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben, muss eine Abwägung zwischen
                Ihren und unseren Interessen vorgenommen werden. Solange noch nicht feststeht, wessen Interessen
                überwiegen, haben Sie das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu
                verlangen.
              </li>
            </ul>
            <p className="mt-3">
              Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten eingeschränkt haben, dürfen diese Daten – von
              ihrer Speicherung abgesehen – nur mit Ihrer Einwilligung oder zur Geltendmachung, Ausübung oder
              Verteidigung von Rechtsansprüchen oder zum Schutz der Rechte einer anderen natürlichen oder juristischen
              Person oder aus Gründen eines wichtigen öffentlichen Interesses der Europäischen Union oder eines
              Mitgliedstaats verarbeitet werden.
            </p>
          </div>

          <div>
            <h3 className="font-display text-xl font-semibold">SSL- bzw. TLS-Verschlüsselung</h3>
            <p className="mt-3">
              Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum
              Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL- bzw.
              TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des
              Browsers von „http://" auf „https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
            </p>
            <p className="mt-3">
              Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln,
              nicht von Dritten mitgelesen werden.
            </p>
          </div>

          <div>
            <h3 className="font-display text-xl font-semibold">Widerspruch gegen Werbe-E-Mails</h3>
            <p className="mt-3">
              Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten zur Übersendung von nicht
              ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit widersprochen. Die Betreiber
              der Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von
              Werbeinformationen, etwa durch Spam-E-Mails, vor.
            </p>
          </div>
        </section>

        {/* 4. Datenerfassung auf dieser Website */}
        <section className="space-y-6">
          <h2 className="font-display text-3xl font-bold">4. Datenerfassung auf dieser Website</h2>

          <div>
            <h3 className="font-display text-xl font-semibold">Cookies</h3>
            <p className="mt-3">
              Unsere Internetseiten verwenden so genannte „Cookies". Cookies sind kleine Datenpakete und richten auf
              Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung
              (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert. Session-Cookies
              werden nach Ende Ihres Besuchs automatisch gelöscht. Permanente Cookies bleiben auf Ihrem Endgerät
              gespeichert, bis Sie diese selbst löschen oder eine automatische Löschung durch Ihren Webbrowser
              erfolgt.
            </p>
            <p className="mt-3">
              Cookies können von uns (First-Party-Cookies) oder von Drittunternehmen stammen (sog.
              Third-Party-Cookies). Third-Party-Cookies ermöglichen die Einbindung bestimmter Dienstleistungen von
              Drittunternehmen innerhalb von Webseiten (z. B. Cookies zur Abwicklung von Zahlungsdienstleistungen).
            </p>
            <p className="mt-3">
              Cookies haben verschiedene Funktionen. Zahlreiche Cookies sind technisch notwendig, da bestimmte
              Webseitenfunktionen ohne diese nicht funktionieren würden (z. B. die Warenkorbfunktion oder die Anzeige
              von Videos). Andere Cookies können zur Auswertung des Nutzerverhaltens oder zu Werbezwecken verwendet
              werden.
            </p>
            <p className="mt-3">
              Cookies, die zur Durchführung des elektronischen Kommunikationsvorgangs, zur Bereitstellung bestimmter,
              von Ihnen erwünschter Funktionen (z. B. für die Warenkorbfunktion) oder zur Optimierung der Website
              (z. B. Cookies zur Messung des Webpublikums) erforderlich sind (notwendige Cookies), werden auf
              Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert, sofern keine andere Rechtsgrundlage angegeben
              wird. Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von notwendigen Cookies zur
              technisch fehlerfreien und optimierten Bereitstellung seiner Dienste. Sofern eine Einwilligung zur
              Speicherung von Cookies und vergleichbaren Wiedererkennungstechnologien abgefragt wurde, erfolgt die
              Verarbeitung ausschließlich auf Grundlage dieser Einwilligung (Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs.
              1 TDDDG); die Einwilligung ist jederzeit widerrufbar.
            </p>
            <p className="mt-3">
              Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und
              Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell
              ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browsers aktivieren. Bei der
              Deaktivierung von Cookies kann die Funktionalität dieser Website eingeschränkt sein.
            </p>
            <p className="mt-3">
              Sofern weitere Cookies und Dienste auf dieser Website eingesetzt werden, können Sie dies dieser
              Datenschutzerklärung entnehmen.
            </p>
          </div>

          <div>
            <h3 className="font-display text-xl font-semibold">Server-Log-Dateien</h3>
            <p className="mt-3">
              Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten
              Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:
            </p>
            <ul className="mt-3 list-disc space-y-1 pl-6">
              <li>Browsertyp und Browserversion</li>
              <li>verwendetes Betriebssystem</li>
              <li>Referrer URL</li>
              <li>Hostname des zugreifenden Rechners</li>
              <li>Uhrzeit der Serveranfrage</li>
              <li>IP-Adresse</li>
            </ul>
            <p className="mt-3">Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.</p>
            <p className="mt-3">
              Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber
              hat ein berechtigtes Interesse an der technisch fehlerfreien Darstellung und der Optimierung seiner
              Website – hierzu müssen die Server-Log-Files erfasst werden.
            </p>
          </div>

          <div>
            <h3 className="font-display text-xl font-semibold">Kontaktformular</h3>
            <p className="mt-3">
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular
              inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall
              von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
            </p>
            <p className="mt-3">
              Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage
              mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen
              erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an
              der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer
              Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde; die Einwilligung ist jederzeit
              widerrufbar.
            </p>
            <p className="mt-3">
              Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns zur Löschung
              auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung
              entfällt (z. B. nach abgeschlossener Bearbeitung Ihrer Anfrage). Zwingende gesetzliche Bestimmungen –
              insbesondere Aufbewahrungsfristen – bleiben unberührt.
            </p>
          </div>

          <div>
            <h3 className="font-display text-xl font-semibold">Einsatz von KI auf der Website</h3>
            <p className="mt-3">Wir nutzen KI-gestützte Dienste und / oder Anwendungen auf unserer Website.</p>
            <p className="mt-3">Wir setzen Künstliche Intelligenz (KI) auf unserer Website wie folgt ein:</p>
            <p className="mt-3">Lovable</p>
            <p className="mt-3">
              Wenn Sie auf unserer Website mit Elementen interagieren oder in Berührung kommen, in denen künstliche
              Intelligenz zu Einsatz kommt (z. B. Chatbot), werden Ihre Eingaben inklusive Metadaten verarbeitet, um
              eine passende Antwort oder Reaktion zu generieren.
            </p>
            <p className="mt-3">
              Die Nutzung dieser KI-gestützten Funktionen erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir
              haben ein berechtigtes Interesse daran, moderne Technologien auf unserer Website einzusetzen, um unsere
              Leistungen und Services zu verbessern und um neue Potenziale aus der Interaktion mit unseren Kunden zu
              erkennen. Falls eine Einwilligung erforderlich ist, erfolgt die Verarbeitung ausschließlich auf
              Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG. Ihre Einwilligung können Sie jederzeit
              widerrufen.
            </p>
            <p className="mt-3">
              Weitere Informationen zur Datenverarbeitung dieses Tools oder Dienstes erhalten Sie an der
              entsprechenden Stelle in dieser Datenschutzerklärung.
            </p>
          </div>

          <div>
            <h3 className="font-display text-xl font-semibold">Anfrage per E-Mail, Telefon oder Telefax</h3>
            <p className="mt-3">
              Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre Anfrage inklusive aller daraus
              hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei
              uns gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
            </p>
            <p className="mt-3">
              Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage
              mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen
              erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an
              der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer
              Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde; die Einwilligung ist jederzeit
              widerrufbar.
            </p>
            <p className="mt-3">
              Die von Ihnen an uns per Kontaktanfragen übersandten Daten verbleiben bei uns, bis Sie uns zur Löschung
              auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung
              entfällt (z. B. nach abgeschlossener Bearbeitung Ihres Anliegens). Zwingende gesetzliche Bestimmungen –
              insbesondere gesetzliche Aufbewahrungsfristen – bleiben unberührt.
            </p>
          </div>
        </section>

        {/* 5. Analyse-Tools und Werbung */}
        <section className="space-y-6">
          <h2 className="font-display text-3xl font-bold">5. Analyse-Tools und Werbung</h2>

          <div>
            <h3 className="font-display text-xl font-semibold">Google Analytics</h3>
            <p className="mt-3">
              Diese Website nutzt Funktionen des Webanalysedienstes Google Analytics. Anbieter ist die Google Ireland
              Limited („Google"), Gordon House, Barrow Street, Dublin 4, Irland.
            </p>
            <p className="mt-3">
              Google Analytics ermöglicht es dem Websitebetreiber, das Verhalten der Websitebesucher zu analysieren.
              Hierbei erhält der Websitebetreiber verschiedene Nutzungsdaten, wie z. B. Seitenaufrufe, Verweildauer,
              verwendete Betriebssysteme und Herkunft des Nutzers. Diese Daten werden dem jeweiligen Endgerät des
              Users zugeordnet. Eine Zuordnung zu einer User-ID erfolgt nicht.
            </p>
            <p className="mt-3">
              Des Weiteren können wir mit Google Analytics u. a. Ihre Maus- und Scrollbewegungen und Klicks
              aufzeichnen. Ferner verwendet Google Analytics verschiedene Modellierungsansätze, um die erfassten
              Datensätze zu ergänzen und setzt Machine-Learning-Technologien bei der Datenanalyse ein.
            </p>
            <p className="mt-3">
              Google Analytics verwendet Technologien, die die Wiedererkennung des Nutzers zum Zwecke der Analyse des
              Nutzerverhaltens ermöglichen (z. B. Cookies oder Device-Fingerprinting). Die von Google erfassten
              Informationen über die Benutzung dieser Website werden in der Regel an einen Server von Google in den
              USA übertragen und dort gespeichert.
            </p>
            <p className="mt-3">
              Die Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung nach Art. 6 Abs. 1 lit. a DSGVO und
              § 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar.
            </p>
            <p className="mt-3">
              Die Datenübertragung in die USA wird auf die Standardvertragsklauseln der EU-Kommission gestützt.
              Details finden Sie hier:{" "}
              <a className="text-electric hover:underline" href="https://business.safety.google/adscontrollerterms/sccs/" target="_blank" rel="noreferrer">
                https://business.safety.google/adscontrollerterms/sccs/
              </a>
              .
            </p>
            <p className="mt-3">
              Das Unternehmen verfügt über eine Zertifizierung nach dem „EU-US Data Privacy Framework" (DPF). Weitere
              Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link:{" "}
              <a className="text-electric hover:underline" href="https://www.dataprivacyframework.gov/participant/5780" target="_blank" rel="noreferrer">
                https://www.dataprivacyframework.gov/participant/5780
              </a>
              .
            </p>
          </div>

          <div>
            <h3 className="font-display text-lg font-semibold">IP Anonymisierung</h3>
            <p className="mt-3">
              Die Google Analytics IP-Anonymisierung ist aktiviert. Dadurch wird Ihre IP-Adresse von Google innerhalb
              von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den
              Europäischen Wirtschaftsraum vor der Übermittlung in die USA gekürzt. Nur in Ausnahmefällen wird die
              volle IP-Adresse an einen Server von Google in den USA übertragen und dort gekürzt. Im Auftrag des
              Betreibers dieser Website wird Google diese Informationen benutzen, um Ihre Nutzung der Website
              auszuwerten, um Reports über die Websiteaktivitäten zusammenzustellen und um weitere mit der
              Websitenutzung und der Internetnutzung verbundene Dienstleistungen gegenüber dem Websitebetreiber zu
              erbringen. Die im Rahmen von Google Analytics von Ihrem Browser übermittelte IP-Adresse wird nicht mit
              anderen Daten von Google zusammengeführt.
            </p>
          </div>

          <div>
            <h3 className="font-display text-lg font-semibold">Browser Plugin</h3>
            <p className="mt-3">
              Sie können die Erfassung und Verarbeitung Ihrer Daten durch Google verhindern, indem Sie das unter dem
              folgenden Link verfügbare Browser-Plugin herunterladen und installieren:{" "}
              <a className="text-electric hover:underline" href="https://tools.google.com/dlpage/gaoptout?hl=de" target="_blank" rel="noreferrer">
                https://tools.google.com/dlpage/gaoptout?hl=de
              </a>
              .
            </p>
            <p className="mt-3">
              Mehr Informationen zum Umgang mit Nutzerdaten bei Google Analytics finden Sie in der
              Datenschutzerklärung von Google:{" "}
              <a className="text-electric hover:underline" href="https://support.google.com/analytics/answer/6004245?hl=de" target="_blank" rel="noreferrer">
                https://support.google.com/analytics/answer/6004245?hl=de
              </a>
              .
            </p>
          </div>

          <div>
            <h3 className="font-display text-lg font-semibold">Auftragsverarbeitung</h3>
            <p className="mt-3">
              Wir haben mit Google einen Vertrag zur Auftragsverarbeitung abgeschlossen und setzen die strengen
              Vorgaben der deutschen Datenschutzbehörden bei der Nutzung von Google Analytics vollständig um.
            </p>
          </div>
        </section>

        {/* 6. Plugins und Tools */}
        <section className="space-y-6">
          <h2 className="font-display text-3xl font-bold">6. Plugins und Tools</h2>

          <div>
            <h3 className="font-display text-xl font-semibold">Google Fonts (lokales Hosting)</h3>
            <p className="mt-3">
              Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten so genannte Google Fonts, die von
              Google bereitgestellt werden. Die Google Fonts sind lokal installiert. Eine Verbindung zu Servern von
              Google findet dabei nicht statt.
            </p>
            <p className="mt-3">
              Weitere Informationen zu Google Fonts finden Sie unter{" "}
              <a className="text-electric hover:underline" href="https://developers.google.com/fonts/faq" target="_blank" rel="noreferrer">
                https://developers.google.com/fonts/faq
              </a>{" "}
              und in der Datenschutzerklärung von Google:{" "}
              <a className="text-electric hover:underline" href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noreferrer">
                https://policies.google.com/privacy?hl=de
              </a>
              .
            </p>
          </div>
        </section>

        {/* 7. Eigene Dienste */}
        <section className="space-y-6">
          <h2 className="font-display text-3xl font-bold">7. Eigene Dienste</h2>

          <div>
            <h3 className="font-display text-xl font-semibold">Google Drive</h3>
            <p className="mt-3">
              Wir haben Google Drive auf dieser Website eingebunden. Anbieter ist die Google Ireland Limited
              („Google"), Gordon House, Barrow Street, Dublin 4, Irland.
            </p>
            <p className="mt-3">
              Google Drive ermöglicht es uns, einen Uploadbereich auf unserer Website einzubinden, in dem Sie Inhalte
              hochladen können. Wenn Sie Inhalte hochladen, werden diese auf den Servern von Google Drive gespeichert.
              Wenn Sie unsere Website betreten, wird außerdem eine Verbindung zu Google Drive aufgebaut, sodass Google
              Drive feststellen kann, dass Sie unsere Website besucht haben.
            </p>
            <p className="mt-3">
              Die Verwendung von Google Drive erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der
              Websitebetreiber hat ein berechtigtes Interesse an einem zuverlässigen Uploadbereich auf seiner Website.
              Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf
              Grundlage von Art. 6 Abs. 1 lit. a DSGVO; die Einwilligung ist jederzeit widerrufbar.
            </p>
            <p className="mt-3">
              Das Unternehmen verfügt über eine Zertifizierung nach dem „EU-US Data Privacy Framework" (DPF). Weitere
              Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link:{" "}
              <a className="text-electric hover:underline" href="https://www.dataprivacyframework.gov/participant/5780" target="_blank" rel="noreferrer">
                https://www.dataprivacyframework.gov/participant/5780
              </a>
              .
            </p>
          </div>

          <div>
            <h3 className="font-display text-lg font-semibold">Auftragsverarbeitung</h3>
            <p className="mt-3">
              Wir haben einen Vertrag über Auftragsverarbeitung (AVV) zur Nutzung des oben genannten Dienstes
              geschlossen. Hierbei handelt es sich um einen datenschutzrechtlich vorgeschriebenen Vertrag, der
              gewährleistet, dass dieser die personenbezogenen Daten unserer Websitebesucher nur nach unseren
              Weisungen und unter Einhaltung der DSGVO verarbeitet.
            </p>
          </div>

          <p className="text-sm text-slate">Quelle: eRecht24</p>
        </section>
      </article>
    </div>
  );
}
